@if (initialized) {
  @if (!highValue) {
    <ngx-slider
      [value]="value"
      [options]="options"
      (valueChange)="onValueChange($event)"
      (highValueChange)="onHighValueChange($event)"
      (userChangeEnd)="onTouched()"></ngx-slider>
  } @else {
    <ngx-slider
      [value]="value"
      [highValue]="highValue"
      [options]="options"
      (valueChange)="onValueChange($event)"
      (highValueChange)="onHighValueChange($event)"
      (userChangeEnd)="onTouched()"></ngx-slider>
  }
}
